module.exports = class Errors {

    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
        this.message = '';
        this.exception = '';
    }

    /**
     * Return the first error.
     */
    first() {
        if (this.any()) {
            return this.errors[Object.keys(this.errors)[0]][0];
        }
        if (this.message) return this.message;
        return this.exception;
    }

    /**
     * Return the first error key.
     */
    firstError() {
        if (this.any()) {
            return Object.keys(this.errors)[0]
        }
        return this.message;
    }

    /**
     * Determine if an errors exists for the given field.
     */
    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    /**
     * Determine if we have any errors.
     */
    any() {
        return this.errors && Object.keys(this.errors).length > 0;
    }

    /**
     * Retrieve the error message for a field.
     */
    get(field) {
        if (this.errors[field]) {
            return this.errors[field][0];
        }
    }

    /**
     * Record the new errors.
     */
    record(errors, message, exception = '') {
        this.errors = errors;
        this.message = message;
        this.exception = exception;
    }


    /**
     * Clear one or all error fields.
     */
    clear(field) {
        if (field) {
            delete this.errors[field];
            return;
        }
        this.errors = {};
    }

    static newBag(errors) {
        var bag = new Errors;
        bag.record(errors.hasOwnProperty('errors') ? error.errors : {}, errors.message, errors.exception);
        return bag;
    }
}
